import i from"store2";import r from"./log.js";const n=o=>{const t=i.namespace("ethos");r("initialize","Ethos Configuration",o),t("configuration",o)};var m=n;export{m as default};
